export function triggerResize(designer?: Designer) {
    designer && designer.eventBus.trigger(designer.eventBus.events.canvasContainerResize);
}
